/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Add_TrackInputs */

const en_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add track`)
};

const fr_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter une piste`)
};

const de_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track hinzufügen`)
};

const it_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi traccia`)
};

const ru_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить трек`)
};

const es_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar pista`)
};

const zh_cn2_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加曲目`)
};

const ja_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックを追加`)
};

const hi_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक जोड़ें`)
};

const pt_pt2_audio_embed_export_add_track = /** @type {(inputs: Audio_Embed_Export_Add_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar faixa`)
};

/**
* | output |
* | --- |
* | "Add track" |
*
* @param {Audio_Embed_Export_Add_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_add_track = /** @type {((inputs?: Audio_Embed_Export_Add_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Add_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_add_track(inputs)
	if (locale === "de") return de_audio_embed_export_add_track(inputs)
	if (locale === "it") return it_audio_embed_export_add_track(inputs)
	if (locale === "ru") return ru_audio_embed_export_add_track(inputs)
	if (locale === "es") return es_audio_embed_export_add_track(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_add_track(inputs)
	if (locale === "ja") return ja_audio_embed_export_add_track(inputs)
	if (locale === "hi") return hi_audio_embed_export_add_track(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_add_track(inputs)
	return en_audio_embed_export_add_track(inputs)
});